import type {
  JsonApiEntity,
  ConfigEntityDetail,
  ConfigEntityDetailAttributes,
} from '@web-config-app/core';

const isConfigEntityDetailAttributes = (
  attributes: unknown,
): attributes is ConfigEntityDetailAttributes =>
  typeof attributes === 'object' &&
  attributes !== null &&
  'entityMetadata' in attributes &&
  attributes.entityMetadata !== null &&
  typeof attributes.entityMetadata === 'object';

const isJsonApiEntity = (data: unknown): data is JsonApiEntity =>
  typeof data === 'object' && data !== null && 'id' in data && 'type' in data;

export const isConfigEntityDetail = (
  data: unknown,
): data is ConfigEntityDetail =>
  isJsonApiEntity(data) &&
  data.type === 'config-entity' &&
  'attributes' in data &&
  isConfigEntityDetailAttributes(data.attributes);
